import styled from 'styled-components';
import { FaSun } from 'react-icons/fa';
import { BsFillMoonStarsFill } from 'react-icons/bs';

// theme toggler
export const ThemeToggle = styled.label`
  position: relative;
  width: 40px;
  height: 28px;
  cursor: pointer;
`;

export const ThemeSliderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: var(--greyBgLight);
  box-shadow: ${(props) => !props.darkTheme && 'inset 0px 0px 5px var(--greyBorderColor)'};
`;

export const ThemeSlider = styled.span`
  position: absolute;
  height: 20px;
  width: 20px;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0px 0px 3px var(--secondary);
  transition: 0.3s;
`;

export const ThemeInput = styled.input`
  display: none;
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + ${ThemeSliderWrapper} {
    background: #323232;
  }
  &:checked + ${ThemeSliderWrapper} ${ThemeSlider} {
    transform: translateY(-50%) translateX(10px);
  }
`;

export const LightModeIcon = styled(FaSun)`
  font-size: 14px;
  color: var(--warning);
  pointer-events: none;
`;

export const DarkModeIcon = styled(BsFillMoonStarsFill)`
  font-size: 14px;
  color: var(--warning);
  pointer-events: none;
`;

// site toggle
export const Toggle = styled.label`
  position: relative;
  width: 46px
  height: 26px
  cursor: pointer;
`;

export const SliderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: ${(props) => (props.isPricing ? 'var(--brandColor)' : props.darkTheme ? 'var(--greyColor)' : 'var(--greyBgLight)')};
  box-shadow: ${(props) => !props.darkTheme && 'inset 0px 0px 5px var(--greyBorderColor)'};
`;

export const Slider = styled.span`
  position: absolute;
  height: 18px;
  width: 18px;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0px 0px 3px var(--secondary);
  transition: 0.3s;
`;

export const Input = styled.input`
  display: none;
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + ${SliderWrapper} {
    background: ${(props) => (props.isPricing ? 'var(--brandColor)' : props.darkTheme ? 'var(--brandColorDark)' : 'var(--brandColor)')};
  }
  &:checked + ${SliderWrapper} ${Slider} {
    transform: translateY(-50%) translateX(18px);
  }
`;

// partner toggle elements
export const PartnerSliderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: ${(props) => (props.isPricing ? 'var(--partnerPlusColor)' : props.darkTheme ? 'var(--greyColor)' : 'var(--greyBgLight)')};
  box-shadow: ${(props) => !props.darkTheme && 'inset 0px 0px 5px var(--greyBorderColor)'};
`;

export const PartnerInput = styled.input`
  display: none;
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + ${PartnerSliderWrapper} {
    background: ${(props) => (props.isPricing ? 'var(--partnerPlusColor)' : props.darkTheme ? 'var(--partnerPlusDark)' : 'var(--partnerPlusColor)')};
  }
  &:checked + ${PartnerSliderWrapper} ${Slider} {
    transform: translateY(-50%) translateX(18px);
  }
`;

// regionals toggle elements
export const RegionalsSliderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: ${(props) => (props.isPricing ? 'var(--regionalsColor)' : props.darkTheme ? 'var(--greyColor)' : 'var(--greyBgLight)')};
  box-shadow: ${(props) => !props.darkTheme && 'inset 0px 0px 5px var(--greyBorderColor)'};
`;

export const RegionalsInput = styled.input`
  display: none;
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + ${RegionalsSliderWrapper} {
    background: ${(props) => (props.isPricing ? 'var(--regionalsColor)' : props.darkTheme ? 'var(--regionalsDark)' : 'var(--regionalsColor)')};
  }
  &:checked + ${RegionalsSliderWrapper} ${Slider} {
    transform: translateY(-50%) translateX(18px);
  }
`;

// juniors toggle elements
export const JuniorsSliderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: ${(props) => (props.isPricing ? 'var(--codeJuniorsColor)' : props.darkTheme ? 'var(--greyColor)' : 'var(--greyBgLight)')};
  box-shadow: ${(props) => !props.darkTheme && 'inset 0px 0px 5px var(--greyBorderColor)'};
`;

export const JuniorsInput = styled.input`
  display: none;
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + ${JuniorsSliderWrapper} {
    background: ${(props) => (props.isPricing ? 'var(--codeJuniorsColor)' : props.darkTheme ? 'var(--codeJuniorsDark)' : 'var(--codeJuniorsColor)')};
  }
  &:checked + ${JuniorsSliderWrapper} ${Slider} {
    transform: translateY(-50%) translateX(18px);
  }
`;
